import React from 'react';
import classNames from 'classnames';
const RadioGroupItem = (props) => {
    const onChange = () => {
        props.setSelected(props.id);
        (props.id === 'new' || props.id === null) && !!props.setAnalytics ? props.setAnalytics() : null;
    };
    return (React.createElement("label", { className: "optionbox__item" },
        React.createElement("input", { type: "radio", className: classNames('optionbox__item__radio', { 'optionbox__item__radio--centered': props.inputCentered }), disabled: props.disabled, name: props.groupId, value: props.id, onChange: onChange, checked: props.selected }),
        props.content));
};
// for type filtering under RadioGroup
RadioGroupItem.defaultProps = {
    __TYPE: 'RadioGroupItem',
};
export default RadioGroupItem;
